import { createAction, props } from '@ngrx/store'

import {
  EQuarterlyDashboardViewMode,
  IQuarterlyDashboardMktCap,
  IQuarterlyDashboardQuarter,
  IQuarterlyDashboardSector,
  IQuarterlyDashboardSectorTop500,
} from '~/core/models'

import { quarterlyDashboardFeatureKey } from './quarterly-dashboard.state'

// quarter
export const getQuarterlyDashboardQuarterData = createAction(`[${quarterlyDashboardFeatureKey}] Get Quarter Data`)

export const setQuarterlyDashboardQuarterSuccess = createAction(
  `[${quarterlyDashboardFeatureKey}] Set Quarter Success`,
  props<{
    data: IQuarterlyDashboardQuarter[]
    effective?: IQuarterlyDashboardQuarter
  }>()
)

export const setQuarterlyDashboardQuarterError = createAction(
  `[${quarterlyDashboardFeatureKey}] Set Quarter Error`,
  props<{
    error: Error
  }>()
)

export const setQuarterlyDashboardQuarterSelected = createAction(
  `[${quarterlyDashboardFeatureKey}] Set Quarter Selected`,
  props<{
    selected?: IQuarterlyDashboardQuarter
  }>()
)

// market cap
export const getQuarterlyDashboardMktCapData = createAction(`[${quarterlyDashboardFeatureKey}] Get MktCap Data`)

export const setQuarterlyDashboardMktCapSuccess = createAction(
  `[${quarterlyDashboardFeatureKey}] Set MktCap Success`,
  props<{
    data: IQuarterlyDashboardMktCap[]
    quarter?: IQuarterlyDashboardQuarter
  }>()
)

export const setQuarterlyDashboardMktCapError = createAction(
  `[${quarterlyDashboardFeatureKey}] Set MktCap Error`,
  props<{
    error: Error
  }>()
)

export const setQuarterlyDashboardMktCapSort = createAction(
  `[${quarterlyDashboardFeatureKey}] Set MktCap Error`,
  props<{
    sortBy: string
    order: 'asc' | 'desc' | ''
  }>()
)

// sector
export const getQuarterlyDashboardSectorData = createAction(`[${quarterlyDashboardFeatureKey}] Get Sector Data`)

export const setQuarterlyDashboardSectorSuccess = createAction(
  `[${quarterlyDashboardFeatureKey}] Set Sector Success`,
  props<{
    data: IQuarterlyDashboardSector[]
    quarter?: IQuarterlyDashboardQuarter
  }>()
)

export const setQuarterlyDashboardSectorError = createAction(
  `[${quarterlyDashboardFeatureKey}] Set Sector Error`,
  props<{
    error: Error
  }>()
)

export const setQuarterlyDashboardSectorSort = createAction(
  `[${quarterlyDashboardFeatureKey}] Set Sector Error`,
  props<{
    sortBy: string
    order: 'asc' | 'desc' | ''
  }>()
)

// sector top 500
export const getQuarterlyDashboardSectorTop500Data = createAction(
  `[${quarterlyDashboardFeatureKey}] Get SectorTop500 Data`
)

export const setQuarterlyDashboardSectorTop500Success = createAction(
  `[${quarterlyDashboardFeatureKey}] Set SectorTop500 Success`,
  props<{
    data: IQuarterlyDashboardSectorTop500[]
    quarter?: IQuarterlyDashboardQuarter
  }>()
)

export const setQuarterlyDashboardSectorTop500Error = createAction(
  `[${quarterlyDashboardFeatureKey}] Set SectorTop500 Error`,
  props<{
    error: Error
  }>()
)

export const setQuarterlyDashboardSectorTop500Sort = createAction(
  `[${quarterlyDashboardFeatureKey}] Set SectorTop500 Error`,
  props<{
    sortBy: string
    order: 'asc' | 'desc' | ''
  }>()
)

// view mode
export const setQuarterlyDashboardViewMode = createAction(
  `[${quarterlyDashboardFeatureKey}] Set View Mode`,
  props<{
    viewMode: EQuarterlyDashboardViewMode
  }>()
)
